import React from "react";
import { connect } from "react-redux";
import {
  Router,
  Route,
  Redirect,
  Switch,
  StaticRouter
} from "react-router-dom";
import { NotificationContainer } from "react-notifications";
import { instanceOf } from "prop-types";
import Dashboard from "../pages/dashboard/dashboard";
import AdminDashboard from "../pages/dashboard/administrator";
import CaretakerDashboard from "../pages/dashboard/caretaker";
import CashierDashboard from "../pages/dashboard/cashier";
import PetshopAdminDashboard from "../pages/dashboard/petshop-admin";
import SuperAdminDashboard from "../pages/super-admin";
import Subscriptions from "../pages/subscriptions";
import SubscriptionsUsersList from "../pages/subscriptions/users-list";
import SubscriptionsMedicalRecordsList from "../pages/subscriptions/medical-records-list";
import SubscriptionsContractsList from "../pages/subscriptions/contracts-list";
import SubscriptionsTreatmentsList from "../pages/subscriptions/treatments-list";
import SubscriptionsCalculatorsList from "../pages/subscriptions/calculators-list";
import Payment from "../pages/payment";
import PaymentIni from "../pages/payment/initialPayment";
import PetshopsList from "../pages/subscriptions/petshops-list";
import ContractList from "../pages/contracts/list";
import AnimalTypesList from "../pages/subscriptions/animal-types-list";
import BreedsList from "../pages/subscriptions/breeds-list";
import BreedersDeliveryList from "../pages/breeders/deliverylist";
import NewContractForm from "../pages/contracts/add";
import MRecordsList from "../pages/medical-records/list";
import MRecordsDeetedList from "../pages/medical-records/list/deleted";
import MRecordsListView from "../pages/medical-records/view";
import NewMRecordForm from "../pages/medical-records/add";
import ContractsView from "../pages/contracts/view";
import Treatments from "../pages/treatments/treatments";
import WooStore from "../pages/woo-store";
import Calculators from "../pages/treatments/calculators";
import Settings from "../pages/settings";
import Users from "../pages/users";
import Profile from "../pages/users/profile";
import LoginPage from "../pages/auth/login";
import CreateShop from "../pages/shop/create";
import ForgotPassword from "../pages/auth/forgotPassword";
import store from "../store";
import DashboardLayout from "../containers/dashboardLayout";
import history from "../history";
import PetStore from "../pages/petstore/petstore";
import Register from "../pages/auth/register";
import BreederListTab from "../pages/breeders/list";
import BreederAddTab from "../pages/breeders/add";
import BreederViewTab from "../pages/breeders/view";
import BreedersApplicationsList from "../pages/breeders/applications/list";
import BreedersApplicationView from "../pages/breeders/applications/view";
import MessagingCampaignList from "../pages/messaging-campaigns/list";
import SocialMediaSubmission from "../pages/social-media-submission/list";
import AdministeredType from "../pages/breeders/administered-type";
import SubscribeToPet from "../pages/subscribe-to-pet/list";
import NotificationList from "../pages/subscribe-to-pet/notifications";
import SubscriberReplies from "../pages/subscribe-to-pet/replies";
import VideoManager from "../pages/video-manager";
import VirtualVisitRequests from "../pages/virtual-visit-request/list";
import AbandonedCarts  from "../pages/abandoned-cart/list";
import QuizWithAnswers  from "../pages/quiz/list";
import LeadInformation from "../pages/lead-information/list";
import LoyalCustomers from "../pages/loyal-customers/list";
import LocationsPage from "../pages/location/pages/list";
import LocationAdd from "../pages/location/pages/add";
import LocationView from "../pages/location/pages/view";
import SalesDashBoard from "../pages/dashboard/adminSalesDashboard";
import BreedSalesDashBoard from "../pages/dashboard/breedSalesDashboard";
import "react-block-ui/style.css";

// import ViewMRecord from '../pages/medical-records/view/mRecordView';
// import ViewContract from '../pages/contracts/view/contractView';
// import ViewCalc from '../pages/treatments/calculators/view/calView';
// import CustomersList from '../pages/subscriptions/customers-list';
// import history from '../history';

const PrivateRoute = ({ component: Component, petshop: petshop, ...rest }) => {
  const state = store.getState();
  const isLoggedIn = state.cognito.user !== null;

  return (
    petshop && (
      <Route
        {...rest}
        render={props =>
          isLoggedIn ? (
            <DashboardLayout {...props}>
              <Component {...props} />
              {""}
            </DashboardLayout>
          ) : (
            <Redirect
              to={{ pathname: "/login", state: { from: props.location } }}
            />
          )
        }
      />
    )
  );
};

const PublicRoute = ({ component: Component, ...rest }) => {
  const [sub] = window.location.hostname.split(".");

  return (
    <Route
      {...rest}
      render={props =>
        sub === "petpos" || sub === "staging" || sub === "localhost" ? (
          <Component {...props} />
        ) : (
          ""
        )
      }
    />
  );
};

class PageRoutes extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    const { PetShopId } = this.props;
    return (
      <div style={{ width: "100%" }}>
        <Router history={history}>
          <Switch>
            <PrivateRoute
              exact
              path="/"
              component={Dashboard}
              petshop={PetShopId}
            />
            <PrivateRoute
              exact
              path="/contracts"
              component={ContractList}
              petshop={PetShopId}
            />
            <PrivateRoute
              exact
              path="/contracts/add"
              component={NewContractForm}
              petshop={PetShopId}
            />
            <PrivateRoute
              exact
              path="/admin-dashboard"
              component={AdminDashboard}
              petshop={PetShopId}
            />
            <PrivateRoute
              exact
              path="/caretaker-dashboard"
              component={CaretakerDashboard}
              petshop={PetShopId}
            />
            <PrivateRoute
              exact
              path="/cashier-dashboard"
              component={CashierDashboard}
              petshop={PetShopId}
            />
            <PrivateRoute
              exact
              path="/petshop-admin-dashboard"
              component={PetshopAdminDashboard}
              petshop={PetShopId}
            />
            <PrivateRoute
              exact
              path="/super-admin-dashboard"
              component={SuperAdminDashboard}
              petshop={PetShopId}
            />
            <PrivateRoute
              exact
              path="/subscriptions"
              component={Subscriptions}
              petshop={PetShopId}
            />
            <PrivateRoute
              exact
              path="/users-list"
              component={SubscriptionsUsersList}
              petshop={PetShopId}
            />
            <PrivateRoute
              exact
              path="/medical-records-list"
              component={SubscriptionsMedicalRecordsList}
              petshop={PetShopId}
            />
            <PrivateRoute
              exact
              path="/contracts-list"
              component={SubscriptionsContractsList}
              petshop={PetShopId}
            />
            {/* <PrivateRoute exact path="/customers-list" component={CustomersList} petshop={PetShopId} /> */}
            <PrivateRoute
              exact
              path="/treatments-list"
              component={SubscriptionsTreatmentsList}
              petshop={PetShopId}
            />
            <PrivateRoute
              exact
              path="/calculators-list"
              component={SubscriptionsCalculatorsList}
              petshop={PetShopId}
            />
            <PrivateRoute
              exact
              path="/payment"
              component={Payment}
              petshop={PetShopId}
            />
            <PrivateRoute
              exact
              path="/payment-ini"
              component={PaymentIni}
              petshop={PetShopId}
            />
            <PrivateRoute
              exact
              path="/petshops-list"
              component={PetshopsList}
              petshop={PetShopId}
            />
            <PrivateRoute
              exact
              path="/animal-types-list"
              component={AnimalTypesList}
              petshop={PetShopId}
            />
            <PrivateRoute
              exact
              path="/breeds-list"
              component={BreedsList}
              petshop={PetShopId}
            />
            <PrivateRoute
              exact
              path="/medical-records"
              component={MRecordsList}
              petshop={PetShopId}
            />
            <PrivateRoute
              exact
              path="/breeders/deliveryList"
              component={BreedersDeliveryList}
              petshop={PetShopId}
            />
            <PrivateRoute
              exact
              path="/medical-records/deleted"
              component={MRecordsDeetedList}
              petshop={PetShopId}
            />
            
            <PrivateRoute
              exact
              path="/medical-records/add"
              component={NewMRecordForm}
              petshop={PetShopId}
            />
            <PrivateRoute
              exact
              path="/medical-records/:id([0-9]+)/:prev([0-9]+)/:next"
              component={MRecordsListView}
              petshop={PetShopId}
            />
            <PrivateRoute
              exact
              path="/contracts/:id([0-9]+)"
              component={ContractsView}
              petshop={PetShopId}
            />
            {/* <PrivateRoute exact path="/medical-records/:recordId" component={ViewMRecord} /> */}
            {/* <PrivateRoute exact path="/contracts/:id" component={ViewContract} /> */}
            {/* <PrivateRoute exact path="/calculators/:id" component={ViewCalc} /> */}
            <PrivateRoute
              exact
              path="/treatments/:option"
              component={Treatments}
              petshop={PetShopId}
            />   
            <PrivateRoute
              exact
              path="/woo-store"
              component={WooStore}
              petshop={PetShopId}
            />
            <PrivateRoute
              exact
              path="/calculators"
              component={Calculators}
              petshop={PetShopId}
            />
            <PrivateRoute
              exact
              path="/settings"
              component={Settings}
              petshop={PetShopId}
            />
            <PrivateRoute
              exact
              path="/users"
              component={Users}
              petshop={PetShopId}
            />
            <PrivateRoute
              exact
              path="/users/:id([0-9]+)"
              component={Profile}
              petshop={PetShopId}
            />
            <PrivateRoute
              exact
              path="/breeders/applications"
              component={BreedersApplicationsList}
              petshop={PetShopId}
            />  
            <PrivateRoute
              exact
              path="/breeders/application/:id([0-9]+)"
              component={BreedersApplicationView}
              petshop={PetShopId}
            />  
            <PrivateRoute
              exact
              path="/breeders"
              component={BreederListTab}
              petshop={PetShopId}
            />         
            <PrivateRoute
              exact
              path="/breeders/add"
              component={BreederAddTab}
              petshop={PetShopId}
            />
            <PrivateRoute
              exact
              path="/breeders/:id([0-9]+)"
              component={BreederViewTab}
              petshop={PetShopId}
            /> 
            <PrivateRoute 
              exact
              path="/messaging-campaigns"
              component={MessagingCampaignList}
              petshop={PetShopId}
            />
            <PrivateRoute 
              exact
              path="/social-media-submission"
              component={SocialMediaSubmission}
              petshop={PetShopId}
            /> 
            <PrivateRoute 
              path="/subscribe-to-pets/:option"
              component={SubscribeToPet}
              petshop={PetShopId}
            />
            <PrivateRoute 
              path="/subscriber-replies"
              component={SubscriberReplies}
              petshop={PetShopId}
            />
            <PrivateRoute 
              exact
              path="/subscribe-messages"
              component={NotificationList}
              petshop={PetShopId}
            />
            <PrivateRoute 
              exact
              path="/medical-records/vaccines-treatments"
              component={AdministeredType}
              petshop={PetShopId}
            />   
            <PrivateRoute 
              exact
              path="/video-manager"
              component={VideoManager}
              petshop={PetShopId}
            />      
            <PrivateRoute
              exact
              path="/virtual-visit-requests"
              component={VirtualVisitRequests}
              petshop={PetShopId}
            />
            <PrivateRoute
              exact
              path="/customers/abandoned-carts"
              component={AbandonedCarts}
              petshop={PetShopId}
            />
            <PrivateRoute
              exact
              path="/customers/loyal-customers"
              component={LoyalCustomers}
              petshop={PetShopId}
            />
            <PrivateRoute
              exact
              path="/quiz"
              component={QuizWithAnswers}
              petshop={PetShopId}
            />  
            <PrivateRoute
              exact
              path="/leads"
              component={LeadInformation}
              petshop={PetShopId}
            />  
            <PrivateRoute
              exact
              path="/location/pages"
              component={LocationsPage}
              petshop={PetShopId}
            /> 
            <PrivateRoute
              exact
              path="/location/pages/add"
              component={LocationAdd}
              petshop={PetShopId}
            /> 
            <PrivateRoute
              exact
              path="/location/pages/view/:id([0-9]+)"
              component={LocationView}
              petshop={PetShopId}
            /> 
             <PrivateRoute
              exact
              path="/sales-dashboard"
              component={SalesDashBoard}
              petshop={PetShopId}
            /> 
            <PrivateRoute
              exact
              path="/breed-sales-dashboard"
              component={BreedSalesDashBoard}
              petshop={PetShopId}
            /> 
            
            <Route exact path="/login" component={LoginPage} />
            <Route exact path="/forgot-password" component={ForgotPassword} />
            <PublicRoute exact path="/create-shop" component={CreateShop} />
            <PublicRoute exact path="/petshop" component={PetStore} />
            <PublicRoute exact path="/register" component={Register} />
          </Switch>
        </Router>
        <NotificationContainer />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    PetShopId: state.petShopReducer.currentPetshop
  };
};

export default connect(mapStateToProps)(PageRoutes);
